/**
 * Utility for handling browser navigation/redirects.
 * This abstraction allows testing by enabling mocking without
 * manipulating the globalThis.location object directly, which is not possible in the Jest JSDOM environment.
 */

/**
 * Redirects to the given URL by replacing the current history entry.
 * This is equivalent to window.location.replace(url).
 * @param url - The URL to redirect to
 */
export const redirectToUrl = (url: string): void => globalThis.location.replace(url);

/**
 * Opens a URL in a new browser tab/window.
 * This is equivalent to window.open(url).
 * @param url - The URL to open
 */
export const openUrlInNewTab = (url: string): Window | null => globalThis.open(url);

/**
 * Redirects to a URL in the current tab by setting location.href.
 * This is equivalent to window.location.href = url.
 * @param url - The URL to redirect to
 */
export const redirectToUrlInCurrentTab = (url: string): void => {
  globalThis.location.href = url;
};

/**
 * Reloads the current page.
 * This is equivalent to window.location.reload().
 */
export const reloadPage = (): void => globalThis.location.reload();
